import React, { forwardRef, memo } from 'react'

const FruitsIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="151.9"
      height="145.6"
      viewBox="0 0 151.9 145.6"
      fill="none"
      {...props}>
      <circle
        cx={31.881}
        cy={43.835}
        r={23.333}
        transform="rotate(-30.058 31.881 43.835)"
        fill="#D15A19"
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x={8.4}
        y={20.3}
        width={46.9}
        height={46.9}>
        <circle
          cx={31.881}
          cy={43.835}
          r={23.333}
          transform="rotate(-30.058 31.881 43.835)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask0)" stroke="#fff" strokeWidth={1.025}>
        <path d="M7.936 44.948 16.809 39.813" />
        <path d="M22.548 66.104 31.421 60.969" />
        <path d="M10.174 59.05 21.266 52.632" />
      </g>
      <ellipse
        cx={35.768}
        cy={41.87}
        rx={21.529}
        ry={23.579}
        transform="rotate(-30.058 35.768 41.87)"
        fill="#FFA300"
      />
      <circle
        cx={105.108}
        cy={101.699}
        r={33.285}
        transform="rotate(-20.782 105.108 101.699)"
        fill="#D15A19"
      />
      <mask
        id="mask1"
        maskUnits="userSpaceOnUse"
        x={71.4}
        y={67.9}
        width={67.2}
        height={67.2}>
        <circle
          cx={105.108}
          cy={101.699}
          r={33.285}
          transform="rotate(-20.782 105.108 101.699)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask1)" stroke="#fff" strokeWidth={1.463}>
        <path d="M71.141 97.761 84.815 92.572" />
        <path d="M86.848 130.905 100.522 125.716" />
        <path d="M71.05 118.131 88.142 111.644" />
      </g>
      <ellipse
        cx={111.033}
        cy={99.828}
        rx={30.712}
        ry={33.637}
        transform="rotate(-20.782 111.033 99.828)"
        fill="#FFA300"
      />
      <ellipse
        cx={102.082}
        cy={28.04}
        rx={25.413}
        ry={27.834}
        transform="rotate(-20.782 102.082 28.04)"
        fill="#FFA300"
      />
    </svg>
  )
)

FruitsIcon.displayName = 'FruitsIcon'

export default memo(FruitsIcon)
